/* ============================================================
   PLURALIST CO. — Main JS v2.0
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── SCROLL REVEALS ── */
  const revels = document.querySelectorAll('.reveal');
  if (revels.length) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1 });
    revels.forEach(el => io.observe(el));
  }

  /* ── ACTIVE NAV ── */
  const path = window.location.pathname;
  document.querySelectorAll('.hd__nav a').forEach(a => {
    const href = a.getAttribute('href');
    if (href === path || (href !== '/' && path.startsWith(href))) a.classList.add('is-active');
  });

  /* ── SP-404 ── */
  const pads   = document.querySelectorAll('.sp__pad');
  const lcdEl  = document.getElementById('sp-lcd');
  const vuBars = document.querySelectorAll('.sp__vu-bar');
  const roleEl = document.getElementById('sp-role');

  if (!pads.length) return;

  const AUDIO = { A1: null, A2: null, B1: null, B2: null };
  const MSGS  = {
    A1: 'A1 — CURATOR. Shape the canon.',
    A2: 'A2 — COLLECTOR. Own the archive.',
    B1: 'B1 — FILM MAKER. Document the moment.',
    B2: 'B2 — ARCHIVIST. Preserve what matters.'
  };

  let selected = null, holdTimer = null, vuTick = null;
  const audioEls = {};
  Object.entries(AUDIO).forEach(([id, url]) => {
    if (url) { const a = new Audio(url); a.loop = true; audioEls[id] = a; }
  });

  function lcd(msg) {
    if (!lcdEl) return;
    lcdEl.textContent = '';
    let i = 0;
    const t = setInterval(() => { lcdEl.textContent += msg[i++]; if (i >= msg.length) clearInterval(t); }, 30);
  }

  function vu(on) {
    clearInterval(vuTick);
    if (!on) { vuBars.forEach(b => b.classList.remove('lit')); return; }
    vuTick = setInterval(() => {
      const n = Math.floor(Math.random() * vuBars.length) + 1;
      vuBars.forEach((b, i) => b.classList.toggle('lit', i < n));
    }, 110);
  }

  function hit(pad) {
    const id = pad.dataset.id;
    pads.forEach(p => p.classList.remove('is-on', 'is-held'));
    clearTimeout(holdTimer);
    if (selected === id) { selected = null; lcd('SELECT YOUR ROLE_'); vu(false); if (roleEl) roleEl.value = ''; return; }
    selected = id;
    pad.classList.add('is-on');
    lcd(MSGS[id]);
    vu(true);
    if (roleEl) roleEl.value = id + ' — ' + pad.querySelector('.sp__pad-name').textContent;
    holdTimer = setTimeout(() => {
      if (selected === id) { pad.classList.remove('is-on'); pad.classList.add('is-held'); if (audioEls[id]) audioEls[id].play().catch(() => {}); }
    }, 280);
  }

  pads.forEach(pad => {
    pad.addEventListener('mousedown', () => hit(pad));
    pad.addEventListener('touchstart', e => { e.preventDefault(); hit(pad); }, { passive: false });
    pad.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); hit(pad); } });
  });

  lcd('SELECT YOUR ROLE_');

  /* ── CATALOG FILTER ── */
  const fBtns  = document.querySelectorAll('.cat-filter__btn');
  const cItems = document.querySelectorAll('.citem');
  fBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      fBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const f = btn.dataset.filter;
      cItems.forEach(item => { item.style.display = (f === 'all' || item.dataset.type === f) ? '' : 'none'; });
    });
  });

});
